import React from 'react';
import { utils as XLSXUtils, writeFile as XLSXWriteFile } from 'xlsx';

import {
    Button,
    Box,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
} from "@mui/material";

import { useCopyToClipboard } from './CopyButton';

const ClassWizardCredentials = ({ className, createdStudents, onDone }) => {
    const [copiedAll, copy] = useCopyToClipboard();

    const handleCopyAll = () => {
        copy(createdStudents
            .map(student => `${student.name}\t${student.email}\t${student.password}`)
            .join('\n'));
    };

    const handleDownload = () => {
        const worksheet = XLSXUtils.json_to_sheet(createdStudents.map(student => ({
            Name: student.name,
            Username: student.email,
            Password: student.password,
        })));
        const workbook = XLSXUtils.book_new();
        XLSXUtils.book_append_sheet(workbook, worksheet, 'Credentials');
        // Class names routinely contain characters that are illegal in
        // filenames (slashes, colons, ...).
        const safeName = (className || 'class').replace(/[\\/:*?"<>|]/g, '-');
        XLSXWriteFile(workbook, `${safeName} credentials.xlsx`);
    };

    return (
        <Box sx={{ textAlign: 'center', p: 4 }}>
            <Typography variant="h5">Generated Student Accounts</Typography>
            <Typography variant="body1" sx={{ mb: 3, pl: '100px', pr: '100px' }}>
                Accounts have been created for the students without an email address.
                Save these credentials now and share them with the students and/or
                their parents — the passwords cannot be shown again, only reset.
            </Typography>

            <TableContainer component={Paper} sx={{ maxHeight: 300, mb: 3 }}>
                <Table stickyHeader size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell>Name</TableCell>
                            <TableCell>Username</TableCell>
                            <TableCell>Password</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {createdStudents.map((student) => (
                            <TableRow key={student.email}>
                                <TableCell>{student.name}</TableCell>
                                <TableCell sx={{ fontFamily: 'monospace' }}>{student.email}</TableCell>
                                <TableCell sx={{ fontFamily: 'monospace' }}>{student.password}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

            <Button variant="outlined" sx={{ mr: 2 }} onClick={handleCopyAll}>
                {copiedAll ? 'Copied!' : 'Copy All'}
            </Button>
            <Button variant="outlined" sx={{ mr: 2 }} onClick={handleDownload}>
                Download .xlsx
            </Button>
            <Button variant="contained" color="primary" onClick={onDone}>
                Done
            </Button>
        </Box>
    );
};

export default ClassWizardCredentials;
